import {useEffect, useState} from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius, calculateRemSize, flex, flexAbsoluteCenter, mh, mr, mv, ph, pv} from "@pg-design/helpers-css";
import {SearchBoldIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {MobileOptionsModal} from "../../../atoms/MobileOptionsModal";
import {MobileSearchFilters} from "../../../search/components/MobileSearchFilters";
import {SearchAutocomplete} from "../../../search/components/search_autocomplete/SearchAutocomplete";
import {SearchAutocompleteDropdown} from "../../../search/components/search_autocomplete/SearchAutocompleteDropdown";
import {SearchAutocompleteWithDropdown} from "../../../search/components/search_autocomplete/SearchAutocompleteWithDropdown";
import {SearchFiltersWithAccordion} from "../../../search/components/SearchFiltersWithAccordion";
import {SearchListingInvestmentViewType, useSearchListingInvestmentViewType} from "../../../search/hooks/use_search_listing_investment_view_type";
import {useSearchParamAbroadCountry} from "../../../search/hooks/use_search_param_abroad_country";
import {useNotificationsFilters} from "../hooks/use_notifications_filters";
import {INotificationsSubscriptionModalProps, SelectedFormValuesType} from "./OfferListNotificationsSubscriptionModal";

interface IProps extends INotificationsSubscriptionModalProps {
    onReset: () => void;
    onSubmit: (values: SelectedFormValuesType) => void;
}

export const OfferListFiltersView = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const [showLocationSearch, setShowLocationSearch] = useState(false);
    const {searchFiltersConfig, countBySlots} = useNotificationsFilters(props.formValues);
    const searchListingInvestmentViewType = useSearchListingInvestmentViewType();
    const searchCountry = useSearchParamAbroadCountry();

    const fetchAllSearchLists = (searchInput: string) => {
        const searchParams =
            searchListingInvestmentViewType === SearchListingInvestmentViewType.ABROAD && searchCountry
                ? {searchContent: {regions: true, vendors: true, offers: true, googlePOIs: false}, country: searchCountry}
                : {searchContent: {regions: true, vendors: true, offers: true, googlePOIs: true}};

        return props.fetchAllSearchLists(searchInput, searchParams);
    };

    useEffect(() => {
        if (!isMobile) {
            setShowLocationSearch(false);
        }
    }, [isMobile]);

    const chosenRegionsCount = props.formValues?.search?.regions?.length;
    return (
        <>
            {isMobile && !showLocationSearch && (
                <MobileOptionsModal modalHeading="Kryteria wyszukiwania" isOpen onModalClose={props.onReset}>
                    <MobileSearchFilters
                        searchFiltersConfig={searchFiltersConfig}
                        searchFiltersCountBySlots={countBySlots}
                        values={props.formValues}
                        onAfterChange={() => null}
                        onChange={props.formActions.update}
                        onSubmit={() => props.onSubmit(props.formValues)}
                        onMobileCloseModal={props.onReset}
                        onMobileResetForm={props.onReset}
                        topContent={
                            <div css={locationButton} onClick={() => setShowLocationSearch(true)}>
                                <Text variant="headline_6" css={mr(1)}>
                                    Lokalizacja
                                </Text>
                                {!!chosenRegionsCount && (
                                    <Text variant="info_txt_1" css={locationCountBadge}>
                                        {chosenRegionsCount}
                                    </Text>
                                )}
                                <SearchBoldIcon size="2.4" wrapperSize="2.4" />
                            </div>
                        }
                    />
                </MobileOptionsModal>
            )}
            {isMobile && showLocationSearch && (
                <MobileOptionsModal modalHeading="Szukaj" isOpen onModalClose={() => setShowLocationSearch(false)}>
                    <SearchAutocompleteWithDropdown
                        onDropdownStatusChange={() => null}
                        formProps={{
                            ...props,
                            fetchAllSearchLists
                        }}
                        onSearchSubmit={() => null}
                        onAfterTabSwitch={() => null}
                        onInputMount={() => null}
                        isInModal
                        includeDistanceFilter
                    />
                </MobileOptionsModal>
            )}
            {!isMobile && (
                <>
                    <div css={searchInputWrapper}>
                        <SearchAutocomplete
                            onChange={props.formActions.update}
                            onDropdownStatusChange={() => null}
                            onAfterTabSwitch={() => null}
                            values={props.formValues}
                            fetchAllSearchLists={fetchAllSearchLists}
                            includeDistanceFilter
                            renderDropdownList={(props) => (
                                <SearchAutocompleteDropdown
                                    dropdownIsOpen={props.dropdownIsOpen}
                                    search={props.search}
                                    selectedTab={props.selectedTab}
                                    onLinkClick={props.onLinkClick}
                                    requestStateObj={props.requestStateObj}
                                    activeItem={props.activeItem}
                                    offers={props.offers}
                                    places={props.places}
                                    regions={props.regions}
                                    removeRegionTag={props.removeRegionTag}
                                    vendors={props.vendors}
                                    getFieldProps={props.getFieldProps}
                                />
                            )}
                        />
                    </div>

                    <SearchFiltersWithAccordion
                        searchFiltersConfig={searchFiltersConfig}
                        searchFiltersCountBySlots={countBySlots}
                        values={props.formValues}
                        onChange={props.formActions.update}
                        onSubmit={() => props.onSubmit(props.formValues)}
                        footerClearButtonText="Anuluj"
                        footerSubmitButtonText="Zatwierdź"
                        onResetForm={props.onReset}
                        isNotificationsSubscriptionModal
                    />
                </>
            )}
        </>
    );
};

const locationButton = (theme: Theme) => css`
    display: flex;
    align-items: center;
    ${mh(2)};
    ${mv(1)};
    border: 1px solid ${theme.colors.gray[500]};
    ${borderRadius(2)};
    ${ph(2)};
    ${pv(2)};

    svg {
        margin-left: auto;
    }
`;

const locationCountBadge = (theme: Theme) => css`
    ${flexAbsoluteCenter};
    background-color: ${theme.colors.primary};
    width: ${calculateRemSize(3)};
    height: ${calculateRemSize(3)};
    border-radius: 50%;
`;

const searchInputWrapper = css`
    ${flex()};
    width: 100%;
    flex: 1 1;
`;
import {useEffect, useState} from "react";
import {css, Theme} from "@emotion/react";

import {borderRadius, calculateRemSize, flex, flexAbsoluteCenter, mh, mr, mv, ph, pv} from "@pg-design/helpers-css";
import {SearchBoldIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {MobileOptionsModal} from "../../../atoms/MobileOptionsModal";
import {MobileSearchFilters} from "../../../search/components/MobileSearchFilters";
import {SearchAutocomplete} from "../../../search/components/search_autocomplete/SearchAutocomplete";
import {SearchAutocompleteDropdown} from "../../../search/components/search_autocomplete/SearchAutocompleteDropdown";
import {SearchAutocompleteWithDropdown} from "../../../search/components/search_autocomplete/SearchAutocompleteWithDropdown";
import {SearchFiltersWithAccordion} from "../../../search/components/SearchFiltersWithAccordion";
import {SearchListingInvestmentViewType, useSearchListingInvestmentViewType} from "../../../search/hooks/use_search_listing_investment_view_type";
import {useSearchParamAbroadCountry} from "../../../search/hooks/use_search_param_abroad_country";
import {useNotificationsFilters} from "../hooks/use_notifications_filters";
import {INotificationsSubscriptionModalProps, SelectedFormValuesType} from "./OfferListNotificationsSubscriptionModal";

interface IProps extends INotificationsSubscriptionModalProps {
    onReset: () => void;
    onSubmit: (values: SelectedFormValuesType) => void;
}

export const OfferListFiltersView = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const [showLocationSearch, setShowLocationSearch] = useState(false);
    const {searchFiltersConfig, countBySlots} = useNotificationsFilters(props.formValues);
    const searchListingInvestmentViewType = useSearchListingInvestmentViewType();
    const searchCountry = useSearchParamAbroadCountry();

    const fetchAllSearchLists = (searchInput: string) => {
        const searchParams =
            searchListingInvestmentViewType === SearchListingInvestmentViewType.ABROAD && searchCountry
                ? {searchContent: {regions: true, vendors: true, offers: true, googlePOIs: false}, country: searchCountry}
                : {searchContent: {regions: true, vendors: true, offers: true, googlePOIs: true}};

        return props.fetchAllSearchLists(searchInput, searchParams);
    };

    useEffect(() => {
        if (!isMobile) {
            setShowLocationSearch(false);
        }
    }, [isMobile]);

    const chosenRegionsCount = props.formValues?.search?.regions?.length;
    return (
        <>
            {isMobile && !showLocationSearch && (
                <MobileOptionsModal modalHeading="Kryteria wyszukiwania" isOpen onModalClose={props.onReset}>
                    <MobileSearchFilters
                        searchFiltersConfig={searchFiltersConfig}
                        searchFiltersCountBySlots={countBySlots}
                        values={props.formValues}
                        onAfterChange={() => null}
                        onChange={props.formActions.update}
                        onSubmit={() => props.onSubmit(props.formValues)}
                        onMobileCloseModal={props.onReset}
                        onMobileResetForm={props.onReset}
                        topContent={
                            <div css={locationButton} onClick={() => setShowLocationSearch(true)}>
                                <Text variant="headline_6" css={mr(1)}>
                                    Lokalizacja
                                </Text>
                                {!!chosenRegionsCount && (
                                    <Text variant="info_txt_1" css={locationCountBadge}>
                                        {chosenRegionsCount}
                                    </Text>
                                )}
                                <SearchBoldIcon size="2.4" wrapperSize="2.4" />
                            </div>
                        }
                    />
                </MobileOptionsModal>
            )}
            {isMobile && showLocationSearch && (
                <MobileOptionsModal modalHeading="Szukaj" isOpen onModalClose={() => setShowLocationSearch(false)}>
                    <SearchAutocompleteWithDropdown
                        onDropdownStatusChange={() => null}
                        formProps={{
                            ...props,
                            fetchAllSearchLists
                        }}
                        onSearchSubmit={() => null}
                        onAfterTabSwitch={() => null}
                        onInputMount={() => null}
                        isInModal
                        includeDistanceFilter
                    />
                </MobileOptionsModal>
            )}
            {!isMobile && (
                <>
                    <div css={searchInputWrapper}>
                        <SearchAutocomplete
                            onChange={props.formActions.update}
                            onDropdownStatusChange={() => null}
                            onAfterTabSwitch={() => null}
                            values={props.formValues}
                            fetchAllSearchLists={fetchAllSearchLists}
                            includeDistanceFilter
                            renderDropdownList={(props) => (
                                <SearchAutocompleteDropdown
                                    dropdownIsOpen={props.dropdownIsOpen}
                                    search={props.search}
                                    selectedTab={props.selectedTab}
                                    onLinkClick={props.onLinkClick}
                                    requestStateObj={props.requestStateObj}
                                    activeItem={props.activeItem}
                                    offers={props.offers}
                                    places={props.places}
                                    regions={props.regions}
                                    removeRegionTag={props.removeRegionTag}
                                    vendors={props.vendors}
                                    getFieldProps={props.getFieldProps}
                                />
                            )}
                        />
                    </div>

                    <SearchFiltersWithAccordion
                        searchFiltersConfig={searchFiltersConfig}
                        searchFiltersCountBySlots={countBySlots}
                        values={props.formValues}
                        onChange={props.formActions.update}
                        onSubmit={() => props.onSubmit(props.formValues)}
                        footerClearButtonText="Anuluj"
                        footerSubmitButtonText="Zatwierdź"
                        onResetForm={props.onReset}
                        isNotificationsSubscriptionModal
                    />
                </>
            )}
        </>
    );
};

const locationButton = (theme: Theme) => css`
    display: flex;
    align-items: center;
    ${mh(2)};
    ${mv(1)};
    border: 1px solid ${theme.colors.gray[500]};
    ${borderRadius(2)};
    ${ph(2)};
    ${pv(2)};

    svg {
        margin-left: auto;
    }
`;

const locationCountBadge = (theme: Theme) => css`
    ${flexAbsoluteCenter};
    background-color: ${theme.colors.primary};
    width: ${calculateRemSize(3)};
    height: ${calculateRemSize(3)};
    border-radius: 50%;
`;

const searchInputWrapper = css`
    ${flex()};
    width: 100%;
    flex: 1 1;
`;
